export const SUBJECT_CODES = {
  MATH: "MATH",
  POLISH: "POLISH",
  ENGLISH: "ENGLISH",
} as const;

export const BASE_SUBJECTS = [SUBJECT_CODES.POLISH, SUBJECT_CODES.MATH, SUBJECT_CODES.ENGLISH];

export const BASE_SUBJECT_CODES = {
  MATH: SUBJECT_CODES.MATH,
  POLISH: SUBJECT_CODES.POLISH,
  ENGLISH: SUBJECT_CODES.ENGLISH,
} as const;

export type SubjectCode = (typeof SUBJECT_CODES)[keyof typeof SUBJECT_CODES];
export type BaseSubjectCode = (typeof BASE_SUBJECTS)[number];
